import React from 'react';

const formatDetailsFeaturesToItemsDropdown = ({ description, features }) => {
  const items = [];

  if (description) {
    items.push({
      key: '1',
      label: (<span className="DropdownProductFeatures-title">Descriçao</span>),
      children: (
        <p className="DropdownProductFeatures-text" dangerouslySetInnerHTML={{ __html: description }} />
      ),
    });
  }

  if (features && features.length) {
    features.forEach(({ name, value }, index) => {
      items.push({
        key: (description) ? index + 2 : index,
        label: (<span className="DropdownProductFeatures-title">{name}</span>),
        children: (
          <p className="DropdownProductFeatures-text" dangerouslySetInnerHTML={{ __html: value }} />
        ),
      });
    });
  }

  return items;
};

export default formatDetailsFeaturesToItemsDropdown;
